import * as firebase from "firebase"
import * as analytics from "./analytics"

const welcomeMessage = `Welcome to Crypto Portfolio Tracker!
Let us know if you have any questions. We read and reply to every message, so please feel free to reach out any time. We'll always get back to you by the next business day (if not sooner!)`

export async function signIn(uid = null) {
	analytics.gaAll(
		"send",
		"event",
		"engagement",
		"login",
		`Google${uid === null ? "" : " (Link)"}`
	)
	const provider = new firebase.auth.GoogleAuthProvider()
	provider.setCustomParameters({
		prompt: "select_account",
	})
	const { user } =
		uid === null
			? await firebase.auth().signInWithPopup(provider)
			: await firebase.auth().currentUser.linkWithPopup(provider)
	if (user.email) {
		window.$crisp.push(["set", "user:email", user.email])
	}
	if (user.displayName) {
		window.$crisp.push(["set", "user:nickname", user.displayName])
	}
	if (uid === null) {
		showWelcomeMessage()
	}
	window.sessionStorage.setItem("isNewSession", "true")
	return user
}

export async function signOut() {
	analytics.gaAll("send", "event", "engagement", "logout")
	await firebase.auth().signOut()
	window.$crisp.push(["do", "session:reset", [false]])
}

export function signInAnonymously() {
	analytics.gaAll("send", "event", "engagement", "login", "Anonymous")
	const user = firebase.auth().signInAnonymously()
	showWelcomeMessage()
	window.sessionStorage.setItem("isNewSession", "true")
	return user
}

function showWelcomeMessage() {
	window.$crisp.push(["do", "message:show", ["text", welcomeMessage]])
}



// WEBPACK FOOTER //
// ./src/user.js